import confetti from "canvas-confetti";

export function fireConfetti() {
  const duration = 2500;
  const end = Date.now() + duration;
  const colors = ["#E63946", "#FFD166", "#0A0A0A", "#FFFFFF"];
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 70, origin: { x: 0 }, colors });
    confetti({ particleCount: 4, angle: 120, spread: 70, origin: { x: 1 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
